import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import menudown from "../src/assets/images/mobile-menu-downarrow.svg";
import menuup from "../src/assets/images/menuup.svg";
import { useTranslation } from "react-i18next";
import SubCategory from "../src/Json/SubCategory.json";
function LibasMenuMens({
  toggleCategory,
  expandedCategory,
  activeFilter,
  setHide,
  setActiveFilter,
  selectedPageNull,
  categoryContainerVariants,
  subcategoryItemVariants,
  navigateToCategory,
  toggleSubcategory,
  expandedSubcategories,
  nestedMenuVariants,
  nestedItemVariants,
}) {
  const { i18n, t } = useTranslation();
  console.log(expandedSubcategories, "this is exapand");
  const ClothesMen = [
    {
      name: "Coats",
    },

    {
      name: "Jackets",
    },
    // {
    //   name: "Leather jackets",
    // },
    {
      name: "Jeans",
    },
    {
      name: "Knitwear & Sweatshirts",
    },
    {
      name: "Polo shirts",
    },
    {
      name: "Shirts",
    },
    {
      name: "Shorts",
    },
    {
      name: "Suits",
    },

    {
      name: "Swimwear",
    },
    {
      name: "T-shirts",
    },
    {
      name: "Trousers",
    },
  ];
  const ShoesMen = [
    {
      name: "Boots",
    },
    {
      name: "Espadrilles",
    },
    {
      name: "Flat shoes",
    },
    {
      name: "Lace-ups",
    },
    {
      name: "Sandals",
    },
    {
      name: "Trainers",
    },
  ];
  const AccMen = [
    {
      name: "Belts",
    },
    {
      name: "Cufflinks",
    },
    {
      name: "Gloves",
    },
    {
      name: "Hats",
    },
    {
      name: "Jewellery",
    },
    {
      name: "Scarves & pocket squares",
    },
    {
      name: "Sunglasses",
    },

    {
      name: "Ties",
    },
    {
      name: "Wallets",
    },
    // {
    //   name: "Watches",
    // },
  ];
  const watchesandJewelryMen = [
    {
      name: "Cufflinks",
    },
    // {
    //   name: "Bracelets",
    // },
  ];

  const BagsMen = [
    {
      id: "pA6VrVYknSqqte0biIaR",
      name: "Bags",
    },
    {
      id: "tjVkKS7xYRxBJKXdB1hI",
      name: "Backpacks",
    },
    {
      id: "H5kq3freQ5aGasd3JVE1",
      name: "Belt bags",
    },
    {
      id: "bSDphwJfLG35T3uBUCmx",
      name: "Travel bags",
    },
  ];
  return (
    <div
      className="category-menu"
      style={{
        color: "#404040",
        fontSize: "14px",
      }}
    >
      {/* Mens */}
      <div className="category-item mt-3">
        <motion.div
          className="d-flex justify-content-between align-items-center p-2 px-3"
          onClick={() => toggleCategory("mensmain")}
          style={{
            borderBottom:
              expandedCategory === "mensmain" ? "none" : "1px solid #dee2e6",
            borderBottomColor:
              expandedCategory === "mensmain" ? "#333" : "#eee",
            borderBottomWidth: expandedCategory === "mensmain" ? "2px" : "1px",
            cursor: "pointer",
          }}
        >
          <Link
            to="/products?gender=KG3s4pPk3arcBux5ERnD"
            className="titlemega"
            style={{
              textDecoration: "none",
            }}
            onClick={(e) => {
              e.stopPropagation();
              if (activeFilter === "mens") {
                setHide(true);
                return;
              } else {
                setActiveFilter("mens");
                setHide(true);
                selectedPageNull();
              }
            }}
          >
            <motion.span
              className=""
              style={{
                color: "#404040",
                fontWeight: expandedCategory === "mensmain" ? "500" : "400",
                textDecoration:
                  expandedCategory === "mensmain" ? "underline" : "none",
              }}
              whileHover={{ scale: 1.02 }}
            >
              {t("Men")}
            </motion.span>
          </Link>

          {/* Animated arrow icon */}
          <motion.div
            animate={{ rotate: expandedCategory === "mensmain" ? 180 : 0 }}
            transition={{ duration: 0.3 }}
          >
            <img
              src={expandedCategory === "mensmain" ? menudown : menudown}
              alt="menudown"
            />
          </motion.div>
        </motion.div>
        <AnimatePresence>
          {expandedCategory === "mensmain" && (
            <motion.div
              className="subcategory-container p-1 px-3"
              initial="hidden"
              animate="visible"
              exit="exit"
              variants={categoryContainerVariants}
            >
              <div className="row">
                <div className="col-12 p-0">
                  {/* submenus of mens */}
                  <ul className="list-unstyled">
                    {/* clothes with nested options */}
                    <motion.li
                      className="p-2"
                      style={{
                        borderBottom: "1px solid #dee2e6",
                      }}
                      variants={subcategoryItemVariants}
                    >
                      <div className="d-flex justify-content-between align-items-center">
                        <Link
                          to={`/products?id=yJDeEt0uKPxfxtqOM42V&gender=KG3s4pPk3arcBux5ERnD`}
                          className="subtitlemega "
                          onClick={() => {
                            // If this filter is already active, return
                            if (activeFilter === "mens") {
                              setHide(true);
                              return;
                            } else {
                              // If activating a new filter, set it as active and reset filters
                              setActiveFilter("mens");
                              setHide(true);
                              selectedPageNull();
                            }
                          }}
                        >
                          <motion.button
                            className="btn btn-link text-decoration-none p-0 text-dark"
                            style={{
                              marginLeft: "15px",
                            }}
                            onClick={() =>
                              navigateToCategory("mens", "clothes")
                            }
                          >
                            {t("Clothes")}
                          </motion.button>
                        </Link>
                        {/* Animated arrow for subcategory */}
                        <motion.span
                          onClick={(e) => {
                            e.stopPropagation();
                            toggleSubcategory("clothes");
                          }}
                          whileHover={{ scale: 1.2 }}
                          whileTap={{ scale: 0.95 }}
                          animate={{
                            rotate: expandedSubcategories.clothes ? 180 : 0,
                          }}
                          transition={{ duration: 0.2 }}
                        >
                          <img
                            src={
                              expandedSubcategories.clothes
                                ? menudown
                                : menudown
                            }
                            alt="menudown"
                          />
                        </motion.span>
                      </div>

                      {/* Nested menu for women clothes */}
                      <AnimatePresence>
                        {expandedSubcategories.clothes && (
                          <motion.ul
                            className="list-unstyled ms-4 mt-2"
                            initial="hidden"
                            animate="visible"
                            exit="exit"
                            variants={nestedMenuVariants}
                          >
                            {ClothesMen?.map((cloth) =>
                              SubCategory?.filter(
                                (subcat) => subcat?.name === cloth?.name
                              )
                                ?.sort((a, b) => (a?.name > b?.name ? 1 : -1))
                                ?.map((sub) => (
                                  <Link
                                    key={sub?.id}
                                    to={`/products?id=yJDeEt0uKPxfxtqOM42V&subcategory=${sub.id}&gender=KG3s4pPk3arcBux5ERnD`}
                                    className="subtitlemega"
                                    onClick={() => {
                                      if (activeFilter === "mens") {
                                        setHide(true);
                                        return;
                                      } else {
                                        setActiveFilter("mens");
                                        setHide(true);
                                        selectedPageNull();
                                      }
                                    }}
                                  >
                                    <motion.li
                                      className="py-1"
                                      variants={nestedItemVariants}
                                    >
                                      <motion.button
                                        className="btn btn-link text-decoration-none p-0 text-dark small"
                                        whileHover={{ x: 3, color: "#000" }}
                                        onClick={() =>
                                          navigateToCategory(
                                            "mens",
                                            "clothes",
                                            sub.slug || sub.name.toLowerCase()
                                          )
                                        }
                                      >
                                        {i18n.language === "en"
                                          ? sub.name
                                          : sub.nameAr}
                                      </motion.button>
                                    </motion.li>
                                  </Link>
                                ))
                            )}
                          </motion.ul>
                        )}
                      </AnimatePresence>
                    </motion.li>

                    {/* shoes with nested options */}
                    <motion.li
                      className="p-2"
                      style={{
                        borderBottom: "1px solid #dee2e6",
                      }}
                      variants={subcategoryItemVariants}
                    >
                      <div className="d-flex justify-content-between align-items-center">
                        <Link
                          to={`/products?id=WJmwaMSWxtl1dK1sPZ1x&gender=KG3s4pPk3arcBux5ERnD`}
                          className=""
                          onClick={() => {
                            // If this filter is already active, return
                            if (activeFilter === "mens") {
                              setHide(true);
                              return;
                            } else {
                              // If activating a new filter, set it as active and reset filters
                              setActiveFilter("mens");
                              setHide(true);
                              selectedPageNull();
                            }
                          }}
                        >
                          <motion.button
                            className="btn btn-link text-decoration-none p-0 text-dark"
                            style={{ marginLeft: "15px" }}
                            whileHover={{ x: 3 }}
                            onClick={() => navigateToCategory("mens", "mens")}
                          >
                            {t("Shoes")}
                          </motion.button>
                        </Link>
                        <motion.span
                          onClick={(e) => {
                            e.stopPropagation();
                            toggleSubcategory("shoes");
                          }}
                          whileHover={{ scale: 1.2 }}
                          whileTap={{ scale: 0.95 }}
                          animate={{
                            rotate: expandedSubcategories.shoes ? 180 : 0,
                          }}
                          transition={{ duration: 0.2 }}
                        >
                          <img
                            src={
                              expandedSubcategories.shoes ? menudown : menudown
                            }
                            alt="menudown"
                          />
                        </motion.span>
                      </div>

                      {/* Nested menu for shoes-women */}
                      <AnimatePresence>
                        {expandedSubcategories?.shoes && (
                          <motion.ul
                            className="list-unstyled ms-4 mt-2"
                            initial="hidden"
                            animate="visible"
                            exit="exit"
                            variants={nestedMenuVariants}
                          >
                            {ShoesMen?.map((shoes) =>
                              SubCategory?.filter(
                                (subcat) =>
                                  subcat?.name === shoes?.name &&
                                  subcat?.idTypeCategory ===
                                    "WJmwaMSWxtl1dK1sPZ1x"
                              )
                                .sort((a, b) => (a?.name > b?.name ? 1 : -1))
                                .map((sub) => (
                                  <Link
                                    key={sub?.id}
                                    to={`/products?id=WJmwaMSWxtl1dK1sPZ1x&subcategory=${sub?.id}&gender=KG3s4pPk3arcBux5ERnD`}
                                    className="subtitlemega"
                                    onClick={() => {
                                      if (activeFilter === "mens") {
                                        setHide(true);
                                        return;
                                      } else {
                                        setActiveFilter("mens");
                                        setHide(true);
                                        selectedPageNull();
                                      }
                                    }}
                                  >
                                    <motion.li
                                      className="py-1"
                                      variants={nestedItemVariants}
                                    >
                                      <motion.button
                                        className="btn btn-link text-decoration-none p-0 text-dark small"
                                        whileHover={{ x: 3, color: "#000" }}
                                        onClick={() =>
                                          navigateToCategory(
                                            "mens",
                                            "shoes",
                                            sub?.slug || sub?.name.toLowerCase()
                                          )
                                        }
                                      >
                                        {i18n.language === "en"
                                          ? sub?.name
                                          : sub?.nameAr}
                                      </motion.button>
                                    </motion.li>
                                  </Link>
                                ))
                            )}
                          </motion.ul>
                        )}
                      </AnimatePresence>
                    </motion.li>

                    {/* Bags with nested options */}
                    <motion.li
                      className="p-2"
                      style={{
                        borderBottom: "1px solid #dee2e6",
                      }}
                      variants={subcategoryItemVariants}
                    >
                      <div className="d-flex justify-content-between align-items-center">
                        <Link
                          to={`/products?id=AqFLulu9y2m4mqEIkch1&gender=KG3s4pPk3arcBux5ERnD`}
                          className=""
                          onClick={() => {
                            // If this filter is already active, return
                            if (activeFilter === "mens") {
                              setHide(true);
                              return;
                            } else {
                              // If activating a new filter, set it as active and reset filters
                              setActiveFilter("mens");
                              setHide(true);
                              selectedPageNull();
                            }
                          }}
                        >
                          <motion.button
                            className="btn btn-link text-decoration-none p-0 text-dark"
                            style={{ marginLeft: "15px" }}
                            whileHover={{ x: 3 }}
                            onClick={() => navigateToCategory("mens", "mens")}
                          >
                            {t("Bags")}
                          </motion.button>
                        </Link>
                        <motion.span
                          onClick={(e) => {
                            e.stopPropagation();
                            toggleSubcategory("mensbags");
                          }}
                          whileHover={{ scale: 1.2 }}
                          whileTap={{ scale: 0.95 }}
                          animate={{
                            rotate: expandedSubcategories.mensbags ? 180 : 0,
                          }}
                          transition={{ duration: 0.2 }}
                        >
                          <img
                            src={
                              expandedSubcategories.mensbags
                                ? menudown
                                : menudown
                            }
                            alt="menudown"
                          />
                        </motion.span>
                      </div>

                      {/* Nested menu for bags */}
                      <AnimatePresence>
                        {expandedSubcategories?.mensbags && (
                          <motion.ul
                            className="list-unstyled ms-4 mt-2"
                            initial="hidden"
                            animate="visible"
                            exit="exit"
                            variants={nestedMenuVariants}
                          >
                            {BagsMen?.map((bag) =>
                              SubCategory?.filter(
                                (subcat) =>
                                  subcat?.name === bag?.name &&
                                  subcat?.idTypeCategory ===
                                    "AqFLulu9y2m4mqEIkch1"
                              )
                                .sort((a, b) => (a?.name > b?.name ? 1 : -1))
                                .map((sub) => (
                                  <Link
                                    key={sub?.id}
                                    to={`/products?id=AqFLulu9y2m4mqEIkch1&subcategory=${sub?.id}&gender=KG3s4pPk3arcBux5ERnD`}
                                    className="subtitlemega"
                                    onClick={() => {
                                      if (activeFilter === "mens") {
                                        setHide(true);
                                        return;
                                      } else {
                                        setActiveFilter("mens");
                                        setHide(true);
                                        selectedPageNull();
                                      }
                                    }}
                                  >
                                    <motion.li
                                      className="py-1"
                                      variants={nestedItemVariants}
                                    >
                                      <motion.button
                                        className="btn btn-link text-decoration-none p-0 text-dark small"
                                        whileHover={{ x: 3, color: "#000" }}
                                        onClick={() =>
                                          navigateToCategory(
                                            "mens",
                                            "bags",
                                            sub?.slug || sub?.name.toLowerCase()
                                          )
                                        }
                                      >
                                        {i18n.language === "en"
                                          ? sub?.name
                                          : sub?.nameAr}
                                      </motion.button>
                                    </motion.li>
                                  </Link>
                                ))
                            )}
                          </motion.ul>
                        )}
                      </AnimatePresence>
                    </motion.li>

                    {/* accessories with nested options */}
                    <motion.li
                      className="p-2"
                      style={{
                        borderBottom: "1px solid #dee2e6",
                      }}
                      variants={subcategoryItemVariants}
                    >
                      <div className="d-flex justify-content-between align-items-center">
                        <Link
                          to={`/products?id=LVw0hUP9kEcd1Qr9CoEk&gender=KG3s4pPk3arcBux5ERnD`}
                          className=""
                          onClick={() => {
                            // If this filter is already active, return
                            if (activeFilter === "mens") {
                              setHide(true);
                              return;
                            } else {
                              // If activating a new filter, set it as active and reset filters
                              setActiveFilter("mens");
                              setHide(true);
                              selectedPageNull();
                            }
                          }}
                        >
                          <motion.button
                            className="btn btn-link text-decoration-none p-0 text-dark"
                            style={{ marginLeft: "15px" }}
                            whileHover={{ x: 3 }}
                            onClick={() => navigateToCategory("mens", "mens")}
                          >
                            {t("Accessories")}
                          </motion.button>
                        </Link>
                        <motion.span
                          onClick={(e) => {
                            e.stopPropagation();
                            toggleSubcategory("mensaccessories");
                          }}
                          whileHover={{ scale: 1.2 }}
                          whileTap={{ scale: 0.95 }}
                          animate={{
                            rotate: expandedSubcategories.mensaccessories
                              ? 180
                              : 0,
                          }}
                          transition={{ duration: 0.2 }}
                        >
                          <img
                            src={
                              expandedSubcategories.mensaccessories
                                ? menudown
                                : menudown
                            }
                            alt="menudown"
                          />
                        </motion.span>
                      </div>

                      {/* Nested menu for mens accessories */}
                      <AnimatePresence>
                        {expandedSubcategories?.mensaccessories && (
                          <motion.ul
                            className="list-unstyled ms-4 mt-2"
                            initial="hidden"
                            animate="visible"
                            exit="exit"
                            variants={nestedMenuVariants}
                          >
                            {AccMen?.map((acc) =>
                              acc?.name === "Jewellery" ? (
                                <Link
                                  key="jewellery-men"
                                  to={`/products?id=07kdA6cD3NDKxX8pQ7w1&gender=KG3s4pPk3arcBux5ERnD`}
                                  className="subtitlemega"
                                  onClick={() => {
                                    if (activeFilter === "mens") {
                                      setHide(true);
                                      return;
                                    } else {
                                      setActiveFilter("mens");
                                      setHide(true);
                                      selectedPageNull();
                                    }
                                  }}
                                >
                                  <motion.li
                                    className="py-1"
                                    variants={nestedItemVariants}
                                  >
                                    <motion.button
                                      className="btn btn-link text-decoration-none p-0 text-dark small"
                                      whileHover={{ x: 3, color: "#000" }}
                                      onClick={() =>
                                        navigateToCategory(
                                          "mens",
                                          "accessories",
                                          "jewellery"
                                        )
                                      }
                                    >
                                      {i18n.language === "en"
                                        ? acc?.name
                                        : acc?.nameAr}
                                    </motion.button>
                                  </motion.li>
                                </Link>
                              ) : (
                                SubCategory?.filter(
                                  (subcat) =>
                                    subcat?.name === acc?.name &&
                                    subcat?.idTypeCategory ===
                                      "LVw0hUP9kEcd1Qr9CoEk"
                                )
                                  .sort((a, b) => (a?.name > b?.name ? 1 : -1))
                                  .map((sub) => (
                                    <Link
                                      key={sub?.id}
                                      to={`/products?id=LVw0hUP9kEcd1Qr9CoEk&subcategory=${sub?.id}&gender=KG3s4pPk3arcBux5ERnD`}
                                      className="subtitlemega"
                                      onClick={() => {
                                        if (activeFilter === "mens") {
                                          setHide(true);
                                          return;
                                        } else {
                                          setActiveFilter("mens");
                                          setHide(true);
                                          selectedPageNull();
                                        }
                                      }}
                                    >
                                      <motion.li
                                        className="py-1"
                                        variants={nestedItemVariants}
                                      >
                                        <motion.button
                                          className="btn btn-link text-decoration-none p-0 text-dark small"
                                          whileHover={{ x: 3, color: "#000" }}
                                          onClick={() =>
                                            navigateToCategory(
                                              "mens",
                                              "accessories",
                                              sub?.slug ||
                                                sub?.name.toLowerCase()
                                            )
                                          }
                                        >
                                          {i18n.language === "en"
                                            ? sub?.name
                                            : sub?.nameAr}
                                        </motion.button>
                                      </motion.li>
                                    </Link>
                                  ))
                              )
                            )}
                          </motion.ul>
                        )}
                      </AnimatePresence>
                    </motion.li>

                    {/* watches and jew with nested options */}
                    <motion.li
                      className="p-2"
                      style={{
                        borderBottom: "1px solid #dee2e6",
                      }}
                      variants={subcategoryItemVariants}
                    >
                      <div className="d-flex justify-content-between align-items-center">
                        <Link
                          to={`/products?subcategory=kYTvn5wAxopx5jpqotC0&gender=KG3s4pPk3arcBux5ERnD`}
                          className=""
                          onClick={() => {
                            // If this filter is already active, return
                            if (activeFilter === "mens") {
                              setHide(true);
                              return;
                            } else {
                              // If activating a new filter, set it as active and reset filters
                              setActiveFilter("mens");
                              setHide(true);
                              selectedPageNull();
                            }
                          }}
                        >
                          <motion.button
                            className="btn btn-link text-decoration-none p-0 text-dark"
                            style={{ marginLeft: "15px" }}
                            whileHover={{ x: 3 }}
                            onClick={() => navigateToCategory("mens", "mens")}
                          >
                            {t("watchesandJewelry")}
                          </motion.button>
                        </Link>
                        <motion.span
                          onClick={(e) => {
                            e.stopPropagation();
                            toggleSubcategory("watchesandJewelrymens");
                          }}
                          whileHover={{ scale: 1.2 }}
                          whileTap={{ scale: 0.95 }}
                          animate={{
                            rotate: expandedSubcategories.watchesandJewelrymens
                              ? 180
                              : 0,
                          }}
                          transition={{ duration: 0.2 }}
                        >
                          <img
                            src={
                              expandedSubcategories.watchesandJewelrymens
                                ? menudown
                                : menudown
                            }
                            alt="menudown"
                          />
                        </motion.span>
                      </div>

                      {/* Nested menu for watchesandJewelry */}
                      <AnimatePresence>
                        {expandedSubcategories?.watchesandJewelrymens && (
                          <motion.ul
                            className="list-unstyled ms-4 mt-2"
                            initial="hidden"
                            animate="visible"
                            exit="exit"
                            variants={nestedMenuVariants}
                          >
                            {watchesandJewelryMen?.map((watchess) =>
                              SubCategory?.filter(
                                (subcat) =>
                                  subcat?.name === watchess?.name &&
                                  subcat?.idTypeCategory ===
                                    "07kdA6cD3NDKxX8pQ7w1"
                              )
                                ?.sort((a, b) => (a?.name > b?.name ? 1 : -1))
                                ?.map((sub) => (
                                  <Link
                                    key={sub?.id}
                                    to={`/products?id=${sub?.idTypeCategory}&subcategory=${sub?.id}&gender=KG3s4pPk3arcBux5ERnD`}
                                    className="subtitlemega"
                                    onClick={() => {
                                      if (activeFilter === "mens") {
                                        setHide(true);
                                        return;
                                      } else {
                                        setActiveFilter("mens");
                                        setHide(true);
                                        selectedPageNull();
                                      }
                                    }}
                                  >
                                    <motion.li
                                      className="py-1"
                                      variants={nestedItemVariants}
                                    >
                                      <motion.button
                                        className="btn btn-link text-decoration-none p-0 text-dark small"
                                        whileHover={{ x: 3, color: "#000" }}
                                        onClick={() =>
                                          navigateToCategory(
                                            "mens",
                                            "jewellery",
                                            sub?.slug || sub?.name.toLowerCase()
                                          )
                                        }
                                      >
                                        {i18n.language === "en"
                                          ? sub?.name
                                          : sub?.nameAr}
                                      </motion.button>
                                    </motion.li>
                                  </Link>
                                ))
                            )}

                            {SubCategory?.filter(
                              (subcat) => subcat?.id === "kYTvn5wAxopx5jpqotC0"
                            )
                              ?.sort((a, b) => (a?.name > b?.name ? 1 : -1))
                              ?.map((sub) => (
                                <Link
                                  key={sub?.id}
                                  to={`/products?subcategory=${sub?.id}&gender=KG3s4pPk3arcBux5ERnD`}
                                  className="subtitlemega"
                                  onClick={() => {
                                    if (activeFilter === "mens") {
                                      setHide(true);
                                      return;
                                    } else {
                                      setActiveFilter("mens");
                                      setHide(true);
                                      selectedPageNull();
                                    }
                                  }}
                                >
                                  <motion.li
                                    className="py-1"
                                    variants={nestedItemVariants}
                                  >
                                    <motion.button
                                      className="btn btn-link text-decoration-none p-0 text-dark small"
                                      whileHover={{ x: 3, color: "#000" }}
                                      onClick={() =>
                                        navigateToCategory(
                                          "mens",
                                          "jewellery",
                                          sub?.slug || sub?.name.toLowerCase()
                                        )
                                      }
                                    >
                                      {i18n.language === "en"
                                        ? sub?.name
                                        : sub?.nameAr}
                                    </motion.button>
                                  </motion.li>
                                </Link>
                              ))}
                            {/* mens jewellery */}
                            {SubCategory?.filter(
                              (subcat) => subcat?.id === "X219u0BbTXGaT93w3na9"
                            )
                              ?.sort((a, b) => (a?.name > b?.name ? 1 : -1))
                              ?.map((sub) => (
                                <Link
                                  key={sub?.id}
                                  to={`/products?subcategory=${sub?.id}&gender=KG3s4pPk3arcBux5ERnD`}
                                  className="subtitlemega"
                                  onClick={() => {
                                    if (activeFilter === "mens") {
                                      setHide(true);
                                      return;
                                    } else {
                                      setActiveFilter("mens");
                                      setHide(true);
                                      selectedPageNull();
                                    }
                                  }}
                                >
                                  <motion.li
                                    className="py-1"
                                    variants={nestedItemVariants}
                                  >
                                    <motion.button
                                      className="btn btn-link text-decoration-none p-0 text-dark small"
                                      whileHover={{ x: 3, color: "#000" }}
                                      onClick={() =>
                                        navigateToCategory(
                                          "mens",
                                          "jewellery",
                                          sub?.slug || sub?.name.toLowerCase()
                                        )
                                      }
                                    >
                                      {i18n.language === "en"
                                        ? sub?.name
                                        : sub?.nameAr}
                                    </motion.button>
                                  </motion.li>
                                </Link>
                              ))}
                          </motion.ul>
                        )}
                      </AnimatePresence>
                    </motion.li>
                  </ul>
                </div>
              </div>
            </motion.div>
          )}
        </AnimatePresence>
      </div>
    </div>
  );
}

export default LibasMenuMens;
